import React from 'react';


import NewMessagePanel from '../shared/NewMessagePanel';
import { SETTINGS_MODAL_CLOSE_BUTTON_CLASS, SETTINGS_MODAL_CLOSE_ICON, SETTINGS_MODAL_TITLE_CLASS } from '../shared/settingsModalChrome';
import { Modal } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalTopBar } from './ModalTopBar';

// Same close-button chrome and top bar as the settings modals (ChannelSettings is
// the reference). padding="none" because NewMessagePanel owns its pinned-search
// scroll layout.
const NewMessageModal = ({ onClose, onNewWorkspaceSelected }) => {
  return (
    <Modal
      onClose={onClose}
      className="rounded-2xl"
      closePlacement="top-left"
      showClose={{ desktop: true, mobile: true }}
      padding="none"
      closeButtonClassName={SETTINGS_MODAL_CLOSE_BUTTON_CLASS}
      closeIcon={SETTINGS_MODAL_CLOSE_ICON}
    >
      <ModalBody padding="none" className="h-full overflow-hidden">
        <div className="shrink-0 pt-5">
          <ModalTopBar className="!pb-0">
            <span className={SETTINGS_MODAL_TITLE_CLASS}>New Chat</span>
          </ModalTopBar>
        </div>
        <NewMessagePanel onMessageOpened={onClose} onNewGroupSelected={onNewWorkspaceSelected} />
      </ModalBody>
    </Modal>
  );
};

export default NewMessageModal;
